import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { type DniAnalysisTransformer } from './transformers'

export const pageViewTransformer: DniAnalysisTransformer = (platform, event) => {
  if (event.eventName !== 'page_view') return event
  const campaignCode = 'campaign_code' in event.eventParams ? event.eventParams.campaign_code : undefined
  if (platform === AnalyticsPlatforms.META_PIXEL) {
    return {
      eventName: 'PageView',
      eventParams: {
        campaign_code: campaignCode,
      },
    }
  }
  /**
   * GA4 會自動送，手動 skip
   */
  if (platform === AnalyticsPlatforms.GA4) {
    return null
  }
  return event
}
